import React from 'react';
import {Button} from "primereact/button";
import Grid from "@material-ui/core/Grid";
import TitlePage from "../../app/Title/TitlePage/TitlePageView";
import {Divider} from "@material-ui/core";

const HeaderScreenPresvalView = (props) => {

    return (
        <React.Fragment>
            <Grid container spacing={1}>
                <Grid item xs={9}>
                    <TitlePage title={props.headerTitle} menuIcon={props.menuIcon}/>
                </Grid>
                <Grid item xs={3}>
                    {props.withButtons &&
                    <div style={{textAlign: 'right'}}>
                        <Button label={props.buttonName}
                                onClick={props.toggleFieldset}
                                className="p-button-secondary-filter"
                                icon={props.icon}
                                iconPos={"right"}
                        />&nbsp; &nbsp;
                        <Button label={"Buscar"}
                                onClick={props.actionSearch}
                                disabled={props.disabledSearchButton}
                        />
                    </div>
                    }
                </Grid>
                <Grid item xs={12}><Divider/></Grid>
                <Grid item xs={12}>
                    <div id="contentFieldset" className={props.contentClass} aria-hidden={props.hiddenContent}
                         style={{padding: '0px'}}>
                        {props.content}
                    </div>
                </Grid>
            </Grid>
        </React.Fragment>
    )
};
export default HeaderScreenPresvalView;